let navigateFunction = null;

export const setNavigate = (navigate) => {
  navigateFunction = navigate;
};

export const navigate = (to) => {
  if (navigateFunction) {
    navigateFunction(to);
  } else {
    console.error("Navigation function not set!");
  }
};